module.exports = __webpack_public_path__ + "static/media/inglewood.a0636b66.jpg";